module.exports = __webpack_public_path__ + "static/img/1.ac9e7f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v14_new_features/1.png
// module id = sllo
// module chunks = 0